import { axiosInstance } from "../axiosInstance";

export const getProgrammes = async (searchTerm, startDate, endDate, pageNumber = 1) => {
    const params = new URLSearchParams();

    if (searchTerm) params.append("q", searchTerm);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (pageNumber) params.append("pageNumber", pageNumber);
    
    const { data } = await axiosInstance.get(`api/programmes?${params.toString()}`)
    return data;
}

export const getUpcomingProgrammes = async () => {
    const { data } = await axiosInstance.get(`api/programmes/upcoming`)
    return data;
}


export const AddProgramme = async (programme) => {
  try {
    const { data } = await axiosInstance.post(`api/programmes`, programme);
    return data;
  } catch (error) {
    throw error;
  }
};